import React from 'react'
import { Cell } from 'react-table';

type TMapper<T> = (item: T) => React.ReactNode;

type TMappingResult = React.ReactNode[] | React.ReactNode | null

const Auxiliary = ({ children }: { children: React.ReactNode }) => <>{children}</>;

let reactId = 0;

const getId = () => `Id_${reactId++}`;

function withKey<T>(mapper: TMapper<T>): TMapper<T> {
  return function (item: T): React.ReactNode {
    return <Auxiliary key={getId()}>{mapper(item)}</Auxiliary>;
  };
}
export function mapping<T>(array: T[] | null | undefined, mapper: TMapper<T>, fallbackElement?: React.ReactNode): TMappingResult {
  if (!Array.isArray(array) || !array.length) return fallbackElement || null;

  
  return array.map(withKey<T>(mapper));
}

function cellContentIsComponent(cell:Cell){
  return cell.value?.constructor?.name === 'Function'

}

export function getRowCellContent(cell: Cell): string | React.ReactNode {
  if(!cellContentIsComponent(cell)) return cell.render('Cell')

  const jsxElement = cell.value(cell)

  return jsxElement;
}